import { signal } from "@preact/signals";
import type { Breadcrumb } from "./interfaces";

const makeBreadcrumbs = () => {
    const items = signal<Breadcrumb[]>([]);

    return {
        items,
    };
};

export default makeBreadcrumbs;
